import { providerConfig } from '../config/providers'
import type { Destination, Language } from '../types'
import { PlaceProviderUnavailableError, type PlaceProvider, type PlaceSearchResponse } from './PlaceProvider'

interface ApiResponse {
  candidates?: Array<Omit<Destination, 'coordinateStatus' | 'provider'>>
  message?: string
}

const hangulPattern = /[\u1100-\u11ff\u3130-\u318f\uac00-\ud7af]/

export function placesLanguageCodeForQuery(query: string, interfaceLanguage: Language): Language {
  return hangulPattern.test(query) ? 'ko' : interfaceLanguage
}

export class GooglePlacesProvider implements PlaceProvider {
  readonly name = 'GooglePlacesProvider'

  async search(query: string, language: Language): Promise<PlaceSearchResponse> {
    let response: Response
    try {
      response = await fetch(providerConfig.places.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ query, languageCode: placesLanguageCodeForQuery(query, language) }),
      })
    } catch {
      throw new PlaceProviderUnavailableError('Google Places 연결을 사용할 수 없습니다.')
    }

    const data = await response.json().catch(() => ({})) as ApiResponse
    if (!response.ok) {
      throw new PlaceProviderUnavailableError(data.message ?? 'Google Places 검색을 사용할 수 없습니다.')
    }
    if (!Array.isArray(data.candidates)) {
      throw new PlaceProviderUnavailableError('Google Places Function을 사용할 수 없습니다.')
    }

    return {
      mode: 'live',
      candidates: data.candidates.slice(0, providerConfig.places.maxCandidates).map((candidate) => ({
        ...candidate,
        coordinateStatus: 'PROVIDER_VERIFIED',
        provider: this.name,
      })),
    }
  }
}
